<template>
  <div id="app">
    <!-- <template v-if="Object.keys(this.db).length !== 0">
      Total: {{ this.enabled.reduce((acc, cur) => ( acc + this.db[cur].length ), 0) }}
    </template> -->

    <div id="input" :class="showOutput ? 'inactive' : 'active'">
      <b-row class="p-0 pb-4 m-0">
        <b-col>
          <div class="heading">
            <!-- <h2>Paste Input Here</h2> -->
          </div>
        </b-col>
        <b-col>
          <b-button variant="success" size="lg" class="float-right" v-on:click="highlight()">Highlight</b-button>
        </b-col>
      </b-row>

      <div id="options">
      <b-form-group label="">
        <b-form-checkbox v-model="toggle" button-variant="outline-secondary" name="toggle-button" button>
          Toggle All
        </b-form-checkbox>
        <!-- <b-form-checkbox-group id="checkbox-group-1" v-model="enabled" name="flavour-1" buttons button-variant="primary"> -->
        <!-- </b-form-checkbox-group> -->
          <!-- <b-form-checkbox v-for="(option, index) in Object.keys(db).sort((a,b)=>a.localeCompare(b))" v-model="enabled" :value="option" :key="index" class="m-1" button button-variant="outline-primary"> -->
          <b-form-checkbox v-for="(option, index) in this.enabledHack" v-model="enabled" :value="option" :key="index" class="m-1" button button-variant="outline-primary">
            {{ option }}
            <!-- {{ option }} {{ enabled.includes(option) ? '&#9745;' : '&#9744;' }} -->
          </b-form-checkbox>

        <!-- <b-dropdown id="dropdown-left" text="Download Databases" variant="success" class="m-0">
          <b-dropdown-item v-for="(option, index) in Object.keys(db)" :key="index" href="#">{{ option }}</b-dropdown-item>
        </b-dropdown> -->
      </b-form-group>
      </div>

        <textarea id="word-input" placeholder="Please paste the text you want to highlight in this box."></textarea>
    </div>
    
    <div id="output" :class="showOutput ? 'active' : 'inactive'">
      <b-row class="p-0 m-0 pb-2">
        <b-col>
          <div class="heading">
            <!-- <h2>Result</h2> -->
          </div>
        </b-col>
        <b-col>
          <b-button class="float-right no-print ml-2" size="lg" variant="outline-primary" v-on:click="goback()">Go Back</b-button>
          <b-button class="float-right no-print" size="lg" variant="outline-dark" v-on:click="print()">
            <svg style="height: 1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45"><defs><clipPath id="A"><path d="M0 36h36V0H0v36z"/></clipPath><clipPath id="B"><path d="M6 24a4 4 0 0 1-4-4h0v-9c0-1 1-3 3-3h26c2 0 3 2 3 3h0v9a4 4 0 0 1-4 4h0H6z"/></clipPath><clipPath id="C"><path d="M0 36h36V0H0v36z"/></clipPath></defs><g transform="matrix(1.25 0 0 -1.25 0 45)"><g clip-path="url(#A)"><g fill="#67757f"><path d="M30 23c0-1.104-.827-2-1.846-2H7.846C6.826 21 6 21.896 6 23v8c0 1.105.826 2 1.846 2h20.308c1.02 0 1.846-.895 1.846-2v-8zm0-18a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V5z"/></g><path d="M27 20a2 2 0 0 0-2-2H11a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V20z" fill="#e1e8ed"/><path d="M34 11c0-1-1-3-3-3H5c-2 0-3 2-3 3v9a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4v-9z" fill="#5dadec"/></g><g clip-path="url(#B)"><path d="M30 11c0 1.105-.977 2-2.182 2H8.182C6.977 13 6 12.105 6 11V7c0-1.104.977-2 2.182-2h19.636C29.023 5 30 5.896 30 7v4z" fill="#292f33"/><path d="M30 21a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-5z" fill="#4289c1"/></g><g clip-path="url(#C)"><path d="M27 2a2 2 0 0 0-2-2H11a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V2z" fill="#e1e8ed"/><path d="M25 7a1 1 0 0 0-1-1H12a1 1 0 1 0 0 2h12a1 1 0 0 0 1-1" fill="#9aaab4"/><path d="M32 16.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 1 0 3 0" fill="#f5f8fa"/><g fill="#9aaab4"><path d="M25 4a1 1 0 0 0-1-1H12a1 1 0 1 0 0 2h12a1 1 0 0 0 1-1m2 5H9v2h18V9z"/></g></g></g></svg>
            Print</b-button>
        </b-col>
      </b-row>
      <hr class="no-print" />
      <div id="legend">
      </div>
      <div id="highlighted">
      </div>
    </div>
  </div>
</template>

<script>
const axios = require('axios')
import _ from 'lodash'
import chroma from 'chroma-js'

var bufWords = []

export default {
  name: 'app',
  components: {
  },
  data: function() {
    return {
      enabledHack: ['R', 'L', 'B', 'V', 'U', 'TH', 'AE', 'AR', 'ER', 'OR', 'A/O', 'ER/OR', 'OR/AR', 'Schwa', 'Short I', 'Names', 'Places', 'Silent', 'Others'],
      enabled: [],
      db: {},
      total: 0,
      toggle: true,
      showOutput: false,
    }
  },
  methods: {
    play: function(word) {
      console.log('play', word)
    },
    // trigger:_.debounce(function() {
    //   this.highlight() }, 150),
    // trigger:_.debounce(function() {
    //   this.highlight() }, 150),
    goback() {
      this.showOutput = false
      // <b-spinner type="border" small></b-spinner>
    },
    print() {
      window.print()
    },
    highlight() {
      let content = document.querySelector('#word-input').value
      let output = document.querySelector('#highlighted')
      let legend = document.querySelector('#legend')
      let input = document.querySelector('#input')

      this.showOutput = true

      if (content == '') {
        output.innerHTML = ''
        return
      }

      // output.querySelectorAll('*').forEach(n => n.remove());
      output.innerHTML = ''
      legend.innerHTML = ''

      var t0 = performance.now()
      // console.log(this.db.length)

      if (this.enabled.length === 0) {
        output.innerHTML = content
        return
      }

      var offsets = {}
      for (let db of this.enabled) {
        for (let word of this.db[db]) {
          let startIndex = 0, index
          const len = word.length
          const search = word.toLowerCase()
          const str = content.toLowerCase()

          while ((index = str.indexOf(search, startIndex)) > -1) {
            let left  = str.charCodeAt(index-1)
            let right = str.charCodeAt(index+search.length)

            // this might break in very surprising ways...
            if ((index === 0 || left < 56) && (right < 56 || index+search.length === str.length))
            {
              if (offsets[index]) {
                offsets[index][1].push(db)
              }
              else {
                offsets[index] = [search, [db]]
              }
            }

            startIndex = index + len
          }
        }
      }

      // console.log(JSON.stringify(offsets))
      // console.log(offsets)
      // return
      // console.log(Object.keys(offsets))
      // return

      let keys = Object.keys(offsets).sort((a, b) => ((parseInt(a) > parseInt(b)) ? 1 : -1))

      if (keys.length === 0) {
        console.log('ding')
        output.innerHTML = content
        return
      }

      // make the legend and colour maps
      // this could really use some cleanup...
      let unsorted = Object.keys(offsets).map((a) => ( offsets[a][1] ))
      let set  = new Set(unsorted.map(JSON.stringify));
      let unique = Array.from(set).map(JSON.parse);
      // console.log(unique.length, 'unique values')
      let colour = chroma.scale('Paired').domain([0,unique.length])
      let conv = {}
      for (let val in unique)
      {
        conv[unique[val]] = colour(val).hex()
      }

      for (let item of Object.keys(conv).sort((a,b)=>a.localeCompare(b))) {
        let thing = document.createElement('span')
        thing.classList.add('legend-item')
        thing.style.background = conv[item]
        thing.style.color = '#fff'
        thing.appendChild(document.createTextNode(item))
        legend.appendChild(thing)
        legend.appendChild(document.createTextNode(' '))
        // console.log(item)
      }


      // FIXME: doesn't work in chrome? stupid!
      let data = content.substring(0, keys[0])
      output.appendChild(document.createTextNode(data))

      // unfortunately this function mutates the DOM but I don't see any other way of doing it...
      function createLink(data, offset) {
        let a = document.createElement("span")
        // let supers = ['⁽⁾', '¹','²','³','⁴','⁵','⁶','⁷','⁸','⁹']
        // let sup = document.createElement('span')
        // sup.appendChild(document.createTextNode(supers[offsets[offset][1].length]))
        var linkText = document.createTextNode(data);
        a.appendChild(linkText);
        a.classList.add('hl');
        a.style.color = conv[offsets[offset][1]]
        a.id = 'hl-' + offsets[offset][0];
        // a.title = "🔊 Click to play
        a.title = "In Databases:\n - " + offsets[offset][1].join("\n - ");
        a.addEventListener('click', function(event) {
          // apparently data is still defined here
          // document.querySelector('#highlighted').classList.toggle('playing')
          // console.log(document.querySelector('#highlighted'))
          a.classList.add('rainbow-text')
          if (bufWords[data]) {
              var url = window.URL.createObjectURL(bufWords[data])
              window.audio = new Audio();
              window.audio.src = url;
              console.log(window.audio)
              window.audio.onended = function() {a.classList.remove('rainbow-text')};
              window.audio.play();
              // a.classList.remove('rainbow-text')
          }
          else {
            axios.get("words/" + data.toLowerCase() + '.wav', { responseType: 'arraybuffer' })
            .then((response) => {
              var blob = new Blob([response.data], { type: 'audio/wav' });
              bufWords[data] = blob
              var url = window.URL.createObjectURL(blob)
              window.audio = new Audio();
              window.audio.src = url;
              window.audio.onended = function() {a.classList.remove('rainbow-text')};
              window.audio.play();
            })
            .catch((error) => {
              console.log(error)
              a.classList.remove('rainbow-text')
            });
          }
          // document.querySelector('#highlighted').classList.remove('playing')
        });
        output.appendChild(a)
        // output.appendChild(sup)
      }

      // split the nodes up first
      for (let key in keys) {
        key = parseInt(key)
        let real = parseInt(keys[key])
        if (real == 0) {
          let data = content.substring(real, real + offsets[real][0].length)
          createLink(data, real);

          if (keys[key + 1]) {
            let rem = content.substring(real + offsets[real][0].length, keys[key + 1])
            output.appendChild(document.createTextNode(rem))
          }
          else {
            let rem = content.substring(real + offsets[real][0].length)
            output.appendChild(document.createTextNode(rem))
          }
        }
        else {
          let data = content.substring(real, real + offsets[real][0].length)
          createLink(data, real);

          if (keys[key + 1]) {
            let rem = content.substring(real + offsets[real][0].length, keys[key + 1])
            output.appendChild(document.createTextNode(rem))
          }
          else {
            let rem = content.substring(real + offsets[real][0].length)
            output.appendChild(document.createTextNode(rem))
          }
        }

      }

      var t1 = performance.now()
      console.log("took " + (t1 - t0) + " milliseconds.")
    }
  },
  computed: {
  },
  watch: {
    toggle: function() {
      if (this.toggle === true)
      this.enabled = this.enabledHack
        // this.enabled = Object.keys(this.db).sort((a,b)=>a.localeCompare(b))
      else
        this.enabled = []
    },
    enabled: function() {
      // console.log(this.enabled)
      // if (this.db.length !== 0)
      //   this.highlight()
    }
  },
  mounted () {
    axios.get('meta.json')
    .then((response) => {
     let unfiltered = response.data
      Object.keys(unfiltered).map(function(old_key) {
        if (old_key.indexOf('|') !== -1) {
          let new_key = old_key.replace('|', '/')
          Object.defineProperty(unfiltered, new_key, Object.getOwnPropertyDescriptor(unfiltered, old_key))
          delete unfiltered[old_key]
        }
      })
      this.db = unfiltered
      this.enabled = this.enabledHack
      // this.db = response.data
      // this.enabled = Object.keys(this.db).sort((a,b)=>a.localeCompare(b))
      // console.log(this.db['OR'])
      // console.log(response.data)
      // sort((a, b) => (a.localeCompare(b)))
      // this.highlight()
    })
    .catch((error) => {
      console.log(error)
    })
  },
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box !important }

body, html {
  /* background: #efefef; */
  color: #000;
}

.active {
  display: block;
}

.inactive {
  display: none;
}

small { font-size: 10pt }

.h2 {
  font-weight: 100;
  font-size: x-large;
  padding: 0.2em;
  border-radius: 0.25em;
  margin-right: 0.25em;
  margin-left: 0.25em;
  line-height: 2em;
}

.hl {
  color: #F1C400;
  font-weight: bold;
  text-decoration: underline;
}

.hl:hover {
  cursor: pointer;
  color: #FEDD00;
}

.heading {
  color: #555;
  letter-spacing: 0.1em;
  height: 5vh;
  padding-left: 1em;
  font-size: 1em;
}
.heading h2 {
  font-weight: 100;
  line-height: 5vh
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 1vmax;
}

#word-input, #highlighted {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 1.5em;
  white-space: pre-wrap;
  padding: 0.5em;
}

#options {
  /* min-height: 10vh; */
}

#legend {
  /* border: 0.1em solid darkblue; */
  /* border-radius: 0.1em; */
  margin-bottom: 1em;
}

#word-input {
  border: 0.1em solid darkcyan;
  border-radius: 0.1em;
}

#highlighted {
  /* border: 0.1em solid darkgreen; */
  border-radius: 0.1em;
  overflow-y: scroll;
}

textarea:focus, input:focus{
    outline: 0;
}

#word-input, #highlighted {
  display: block;
  width: 98vw;
}

#output {
}

.legend-item {
  font-size: x-large;
  border-radius: 0.25em;
  padding: 0.1em 0.25em;
  margin: 0.1em;
  color-adjust: exact;
}

#legend {
  /* min-height: 10vh; */
}

#legend span {
  display: inline-block;
}

#word-input {
  min-height: 80vh;
  width: 96vw;
  overflow-y: visible;
}

#highlighted {
  min-height: 80vh;
  overflow-y: visible;
}

#word-input, #highlighted, #legend {
  /* background: #fafafa; */
  color: #222;
}

/* .playing {
  border: 10px solid red;
} */

.test {
  font-size: x-large;
}

@keyframes rainbow-text {
  0% {
    color: #e87d7d;
  }
  2% {
    color: #e88a7d;
  }
  4% {
    color: #e8977d;
  }
  6% {
    color: #e8a47d;
  }
  8% {
    color: #e8b07d;
  }
  10% {
    color: #e8bd7d;
  }
  12% {
    color: #e8ca7d;
  }
  14% {
    color: #e8d77d;
  }
  16% {
    color: #e8e47d;
  }
  18% {
    color: #dfe87d;
  }
  20% {
    color: #d3e87d;
  }
  22% {
    color: #c6e87d;
  }
  24% {
    color: #b9e87d;
  }
  26% {
    color: #ace87d;
  }
  28% {
    color: #9fe87d;
  }
  30% {
    color: #92e87d;
  }
  32% {
    color: #86e87d;
  }
  34% {
    color: #7de881;
  }
  36% {
    color: #7de88e;
  }
  38% {
    color: #7de89b;
  }
  40% {
    color: #7de8a8;
  }
  42% {
    color: #7de8b5;
  }
  44% {
    color: #7de8c1;
  }
  46% {
    color: #7de8ce;
  }
  48% {
    color: #7de8db;
  }
  50% {
    color: #7de8e8;
  }
  52% {
    color: #7ddbe8;
  }
  54% {
    color: #7dcee8;
  }
  56% {
    color: #7dc1e8;
  }
  58% {
    color: #7db5e8;
  }
  60% {
    color: #7da8e8;
  }
  62% {
    color: #7d9be8;
  }
  64% {
    color: #7d8ee8;
  }
  66% {
    color: #7d81e8;
  }
  68% {
    color: #867de8;
  }
  70% {
    color: #927de8;
  }
  72% {
    color: #9f7de8;
  }
  74% {
    color: #ac7de8;
  }
  76% {
    color: #b97de8;
  }
  78% {
    color: #c67de8;
  }
  80% {
    color: #d37de8;
  }
  82% {
    color: #df7de8;
  }
  84% {
    color: #e87de4;
  }
  86% {
    color: #e87dd7;
  }
  88% {
    color: #e87dca;
  }
  90% {
    color: #e87dbd;
  }
  92% {
    color: #e87db0;
  }
  94% {
    color: #e87da4;
  }
  96% {
    color: #e87d97;
  }
  98% {
    color: #e87d8a;
  }
  100% {
    color: #e87d7d;
  }
}
.rainbow-text {
  animation: rainbow-text 1s infinite;
}

@media print
{    
    .no-print, .no-print *
    {
        display: none !important;
    }
}
</style>
